import { Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '../../../global/services/auth.service';

@Pipe({
  name: 'checkShipperPermission',
  standalone: true,
})
export class CheckShipperPermissionPipe implements PipeTransform {
  constructor(private authService: AuthService) {}

  transform(permission: string): boolean {
    return this.authService.shipperHasPermission([permission]);
  }
}
